/**
 * AccountingModeContext - DEPRECATED shim (Sprint 1, F1.1)
 * =========================================================
 *
 * Consolidated into `DisplayModeContext`. This file remains as a thin
 * re-export so any orphan imports (and the existing
 * `AccountingModeToggle` component) keep functioning until migrated.
 *
 * New code MUST import `useDisplayMode` from `./DisplayModeContext`.
 */
import React from 'react';
import {
  useDisplayMode,
} from './DisplayModeContext';
import {
  DISPLAY_MODES,
  LABELS,
  ACCOUNTANT_ONLY_FEATURES,
  MODE_REPORTS,
  GLOSSARY,
} from './displayLabels';

// Preserve the legacy `MODES` enum (standard/accounting) and the public
// constants the old context exposed.
export const MODES = {
  STANDARD: DISPLAY_MODES.BUSINESS,
  ACCOUNTING: DISPLAY_MODES.ACCOUNTANT,
};

export const STANDARD_MODE_LABELS = { ...LABELS };

export { ACCOUNTANT_ONLY_FEATURES };
export const MODE_REPORTS_LEGACY = MODE_REPORTS;
export { MODE_REPORTS };
export const BUSINESS_EXPLANATIONS = GLOSSARY;

// AccountingModeProvider is now a passthrough - the canonical provider
// is `DisplayModeProvider` (mounted higher in App.js). Leaving the legacy
// component in place avoids touching dozens of provider mount-points.
export const AccountingModeProvider = ({ children }) => children;

export const useAccountingMode = () => {
  const ctx = useDisplayMode();
  return {
    mode: ctx.mode,
    isStandardMode: ctx.isBusinessMode,
    isAccountingMode: ctx.isAccountantMode,
    showModeExplanation: false,
    setShowModeExplanation: () => {},
    toggleMode: ctx.toggleMode,
    switchToMode: ctx.switchToMode,
    getLabel: ctx.getLabel,
    isFeatureVisible: ctx.isFeatureVisible,
    getAvailableReports: ctx.getAvailableReports,
    getExplanation: (key) => (GLOSSARY[key]?.short || null),
    formatTransaction: (type, amount, currency = 'NGN') => {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 2,
      });
      if (ctx.isBusinessMode) {
        return type === 'debit'
          ? `+${formatter.format(amount)} (increase)`
          : `-${formatter.format(amount)} (decrease)`;
      }
      return type === 'debit' ? `Dr ${formatter.format(amount)}` : `Cr ${formatter.format(amount)}`;
    },
    getTerm: (term) => ctx.getLabel(term),
    MODES,
    STANDARD_MODE_LABELS,
    ACCOUNTANT_ONLY_FEATURES,
    MODE_REPORTS,
    BUSINESS_EXPLANATIONS: GLOSSARY,
  };
};

const _AccountingModeContext = React.createContext(null);
export default _AccountingModeContext;
